import { useState } from "react";
import LanguageImg from "../assets/images/languages.png";
import ABCImg from "../assets/images/abc.jpeg";
import { useQuery } from "@tanstack/react-query";
import { StarsLanguages } from "../http/server-apis";
// import Loader from "./loaders/loader";
import { Skeleton } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { languageAction } from "../store/languageSlice";
import i18next from "i18next";

const LanguageList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.Language);

  const [languageList, setLanguageList] = useState([]);
  const languageLoader = [1, 2, 3, 4, 5];

  const { isLoading } = useQuery(
    ["get-all-languge"],
    () => StarsLanguages("get"),
    {
      onSuccess(data) {
        if (data?.status === 200)
          if (data.data.Status === "success") {
            //Manipulate Response
            const manipulatedLang = changeLangCode(data.data.Language);
            setLanguageList(
              data.data.Language instanceof Array ? manipulatedLang : []
            );
          }
      },
    }
  );

  function changeLangCode(languageArray) {
    const updatedLangCode = languageArray.map((language) => {
      const LangCode = handleLanguageFunction(language.Language);
      return {
        ...language,
        LangCode,
      };
    });
    return updatedLangCode;
  }

  const handleLanguageFunction = (lang) => {
    switch (lang) {
      case "Hindi":
        return "hi";

      case "Egyptian":
        return "eg";

      case "English":
        return "en";

      case "Polish":
        return "po";

      case "Tigrinya":
        return "ti";

      case "Arabic":
        return "arb";

      case "Pashtoo":
        return "pt";

      case "Kurdish":
        return "ku";

      case "Albanian":
        return "al";
      default:
        return "en";
    }
  };

  const handleLanguageChange = (LangCode) => {
    dispatch(languageAction(LangCode));
    i18next.changeLanguage(LangCode);
    if (user === null || user === "Guest User") {
      navigate("/login");
    } else {
      navigate("/home");
    }
  };

  return (
    <div className="pt-[15%]">
      <p className="text-black text-lg  font-semibold text-center">
        Choose Your Language
      </p>
      <img src={LanguageImg} alt="language" className="w-16 mx-auto m-5" />
      <div>
        {isLoading ? (
          languageLoader.map((index) => (
            <Skeleton
              key={index}
              sx={{ margin: "12px 0px", width: "100%" }}
              animation="wave"
              variant="rounded"
              height={40}
            />
          ))
        ) : (
          <div>
            {languageList.map((lang, index) => (
              <div
                key={index}
                className="w-[90%] border border-gray-400  mx-auto my-4 rounded-md p-2 flex items-center hover:bg-slate-50 scale-105"
                onClick={() => handleLanguageChange(lang.LangCode)}
              >
                <div className="w-[8%]  mr-2">
                  {" "}
                  <img src={ABCImg} alt="abc" className="w-full " />
                </div>

                <p className=" text-sm md:text-base md:font-semibold font-normal mb-0 w-[62%]">
                  {lang.NativeLanguage}
                </p>
                <p className=" text-sm font-normal mb-0 w-[30%] text-right">
                  {lang.Language}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageList;
